import { h } from "preact";

import classname from "../../../foundation/utils/classname";
import IconProps from "../IconProps";

import "./style.css";

function IconSpinner({ color, width, height, class: cssClass }: IconProps) {
    const classes = classname("iconSpinner", cssClass);
    return (
        <svg class={classes} width={width} height={height} viewBox="0 0 12 12">
            <g fill={color} fill-rule="evenodd">
                <path d="M4.328 3.606c-.398.035-.75-.256-.784-.657L3.354.785c-.034-.398.258-.748.658-.783.398-.035.75.257.784.657l.19 2.163c.034.398-.257.748-.658.783z"/>
                <path d="M3.125 5.49c-.257.306-.71.348-1.02.09L.444 4.183c-.306-.257-.348-.71-.09-1.02.258-.305.712-.347 1.02-.088L3.036 4.47c.306.258.348.712.09 1.02z" opacity=".3"/>
                <path d="M3.606 7.672c.035.398-.256.75-.657.784l-2.164.19c-.398.034-.748-.258-.783-.658-.035-.398.257-.75.657-.784l2.163-.19c.398-.034.748.257.783.658z" opacity=".4"/>
                <path d="M5.49 8.875c.306.257.348.71.09 1.02l-1.396 1.662c-.257.306-.71.348-1.02.09-.305-.258-.347-.712-.088-1.02L4.47 8.964c.258-.306.712-.348 1.02-.09z" opacity=".5"/>
                <path d="M7.672 8.394c.398-.035.75.256.784.657l.19 2.164c.034.398-.258.748-.658.783-.398.035-.75-.257-.784-.657l-.19-2.163c-.034-.398.257-.748.658-.783z" opacity=".6"/>
                <path d="M8.875 6.51c.257-.306.71-.348 1.02-.09l1.662 1.396c.306.257.348.71.09 1.02-.258.305-.712.347-1.02.088L8.964 7.53c-.306-.258-.348-.712-.09-1.02z" opacity=".7"/>
                <path d="M8.394 4.328c-.035-.398.256-.75.657-.784l2.164-.19c.398-.034.748.258.783.658.035.398-.257.75-.657.784l-2.163.19c-.398.034-.748-.257-.783-.658z" opacity=".85"/>
                <path d="M6.51 3.125c-.306-.257-.348-.71-.09-1.02L7.817.444c.257-.306.71-.348 1.02-.09.305.258.347.712.088 1.02L7.53 3.036c-.258.306-.712.348-1.02.09z" opacity=".95"/>
            </g>
        </svg>
    );
}

IconSpinner.defaultProps = {
    color: "var(--teflon)",
    width: 12,
    height: 12
};

export default IconSpinner;
